// store.js
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk'
import authReducer from './reducers/authReducer';
import loadingReducer from './reducers/loadingReducer';
import userReducer from './reducers/userReducer';
import leadReducer from './reducers/leadReducer';
import organizationReducer from './reducers/organizationReducer';
import customerReducer from './reducers/customerReducer';
import formLayoutReducer from './reducers/formLayoutReducer';
import accountReducer from './reducers/accountReducer';
import sessionTimeoutReducer from './reducers/sessionTimeOutReducer';
import rolesReducer from './reducers/rolesReducer';
import permissionReducer from './reducers/permissionReducer';
import themeReducer from './reducers/themeReducer';
import dropDownReducer from './reducers/dynamicDropDownReducer';
import policyReducer from './reducers/policyReducer';
import taskReducer from './reducers/taskReducer';
import noteReducer from './reducers/noteReducer';
import generalPartyInfoReducer from './reducers/generalPartyInfoReducer';
import driverInfoReducer from './reducers/driverInfoReducer';
import vehicleInfoReducer from './reducers/vehicleInfoReducer';
import exclusionsInfoReducer from './reducers/exclusionsInfoReducer';
import carrierSelectionsInfoReducer from './reducers/carrierSelectionsInfoReducer';
import carrierQuestionsInfoReducer from './reducers/carrierQuestionsInfoReducer';
import priorInsuranceCarriersReducer from './reducers/priorInsuranceCarriersReducer';
import companyselectionReducer from './reducers/companyReducer';
import dashboardReducer from './reducers/dashboardReducer';
import locationGroupsReducer from './reducers/locationGroupsReducer';

///New Design
import newleadReducer from './reducers/newleadReducer';
import quotelistingReducer from './reducers/quotelistingReducer';
import communicationReducer from './reducers/communicationReducer';
import uploadAttachmentReducer from './reducers/uploadAttachmentReducer';
import policyDetailReducer from './reducers/policyDetailReducer';
import agencyReducer from './reducers/agencyReducer';
import locationReducer from './reducers/locationReducer';
import gailReducer from './reducers/gailReducer';
import botReducer from './reducers/botReducer';
import activityReducer from './reducers/activityReducer';
import themeSettingReducer from './reducers/themeSettingReducer';
import policyTransactionHistoryReducer from './reducers/policyTransactionHistoryReducer';
import smsTemplateReducer from './reducers/smsTemplateReducer';
import customerSearchReducer from './reducers/customerSearchReducer';
import notificationPanelReducer from './reducers/notificationPanelReducer';
import folderSectionReducer from './reducers/folderSectionReducer';
import customerDetailsReducer from './reducers/customerDetailsReducer';
import createCustomerReducer from './reducers/createCustomerReducer';
import reportReducer from './reducers/reportReducer';
import cityAddressReducer from './reducers/cityAddressReducer';
import CSVImportReducer from './reducers/CSVImportReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  loading: loadingReducer,
  user: userReducer,
  leads: leadReducer,
  organizations: organizationReducer,
  customers: customerReducer,
  formLayout: formLayoutReducer,
  accounts: accountReducer,
  sessionTimeoutModal: sessionTimeoutReducer,
  roles: rolesReducer,
  permissions: permissionReducer,
  theme: themeReducer,
  dropDowns: dropDownReducer,
  newleads: newleadReducer,
  policy:policyReducer,
  task:taskReducer,
  note:noteReducer,
  generalPartyInfo: generalPartyInfoReducer,
  driverInfo: driverInfoReducer,
  vehicleInfo: vehicleInfoReducer,
  exclusionsInfo: exclusionsInfoReducer,
  carrierSelectionsInfo: carrierSelectionsInfoReducer,
  carrierQuestionsInfo: carrierQuestionsInfoReducer,
  priorInsuranceCarriers:priorInsuranceCarriersReducer,
  companies:companyselectionReducer,
  quotelisting:quotelistingReducer,
  communication:communicationReducer,
  uploadAttachment:uploadAttachmentReducer,
  policyDetail:policyDetailReducer,
  agency:agencyReducer,
  location:locationReducer,
  dashboardData: dashboardReducer,
  gail:gailReducer,
  bot:botReducer,
  allActivity: activityReducer,
  locationGroup:locationGroupsReducer,
  setThemeReducer: themeSettingReducer,
  policyTransactionHistory:policyTransactionHistoryReducer,
  templateReducer:smsTemplateReducer,
  globalSearchReducer: customerSearchReducer,
  notificationPanel: notificationPanelReducer,
  smsTemplates: smsTemplateReducer,
  foldersection:folderSectionReducer,
  customerDetails: customerDetailsReducer,
  createCustomer: createCustomerReducer,
  allReportReducer: reportReducer,
  cityAddress: cityAddressReducer,
  CSVFiles: CSVImportReducer,
});

const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);

export default store;
